import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';
import { VirtualTranslatorService } from 'src/core/models/generic-lookup-type/virtual-translator/services.glt';
import { map } from 'rxjs';
import { Store } from '@ngxs/store';

@Component({
    selector: 'virtual-translator-settings',
    templateUrl: './virtual-translator-settings.component.html',
    styleUrls: ['./virtual-translator-settings.component.scss'],
    standalone: false
})
export class VirtualTranslatorSettingsComponent implements OnInit {
  form: FormGroup;
  serviceComboboxValue: string;
  serviceTypes: GenericLookupDto[];

  private readonly prefix = 'VirtualTranslator';
  private readonly service = this.prefix + '.Service';

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService,
    private store: Store
  ) {
    this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(VirtualTranslatorService)))
      .subscribe(result => {
        this.serviceTypes = result;
      });

    this.serviceComboboxValue = this.config.getSetting(this.service);

    this.form = this.fb.group({
      service: [this.serviceComboboxValue, Validators.required]
    });
  }

  isServiceSelected(serviceName): boolean {
    const serviceValue = this.form?.get('service').value;
    return serviceValue && serviceValue === serviceName;
  }

  ngOnInit(): void {}

  onSubmitForm(eventArgs): void {
    if (!this.form.valid) {
      return;
    }
    const settings: ConfigurationSettingsDto[] = [];

    settings.push(
      {
        settingName: this.service,
        settingValue: this.form.get('service').value,
      }
    );

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
